<template>
	<div class="modularContent">
		<div class="contentbox">
			
			<div class="bodybox">
				<div class="PatentNature" style="margin-top: 40px;">
					<div style="display: flex;">
						<div>专利名称：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>申请人：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>专利名称：</div>
						<div class="inputbox"></div>
					</div>
				</div>
				<div class="PatentNature">
					<div style="display: flex;">
						<div>专利类型:&nbsp;&nbsp; </div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>提交方式：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>状态：</div>
						<div class="inputbox"></div>
					</div>
				</div>
				<div class="PatentNature">
					<div style="display: flex;">
						<div>提交日期：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>授权日期：</div>
						<div class="inputbox"></div>
					</div>
					<div style="display: flex;">
						<div>123</div>
						<div class="inputbox"></div>
					</div>
				</div>
				<div class="btnbox">
					<div class="querybtn">查询</div>
					<div class="emptybtn">清空</div>
					<div class="emptybtn">导出</div>
					<div class="querybtn" @click="addPage">添加</div>
				</div>
				<div class="tablebox">
					<el-table :data="tableData">
						<el-table-column type="index" label="序号" align="center" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="name" label="专利名称" align="center" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="address" label="第一权利人名称" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address1" label="专利性质" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address2" label="专利类型" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address3" label="提交方式" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address4" label="状态" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address5" label="提交日期" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address6" label="授权日期" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="address7" label="操作" show-overflow-tooltip align="center">
						</el-table-column>
					</el-table>
				</div>
				<div class="fenye">
					<!-- 分页 -->
					<!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100"
						layout="  prev, pager, next, jumper" :total="400">
					</el-pagination> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {auditList} from '@/api/home.js'
	export default {
		name: "patentManagement",
		data() {
			return {
				tableData: [],
				currentPage4: 4
			}
		},
		components: {
		},
		mounted() {
			this.auditLists(1)
		},
		methods: {
			// 审批列表
			async auditLists(val,SubmitObj){
				let obj
				if(SubmitObj == 1){
					 obj = {
						 status:val,
						 page_num:this.SubmitObj.page_num,
						 page_size:3
					 }
				}else{
					obj = {status:val}
				}
				let res = await auditList(obj)
				if(res.code = '00000'){
					let aa = 'patent'
					if(aa = 'patent'){
						// this.tableData = res.data.patent.result
						// this.total_count = res.data.patent.total_count
						
					}else if( aa = 'software'){
						// this.tableData = res.data.software.result
						// this.total_count = res.data.software.total_count
					}else if(aa = 'trademark'){
						// this.tableData = res.data.trademark.result
						// this.total_count = res.data.trademark.total_count
					}
				}
			},
			
			
			
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			addPage() {
				this.$router.push('./AddPatent')
			}
		}
	}
</script>

<style scoped lang="less">
	.modularBox>.modularContent {
		width: 95%;
		height: 95%;
		margin: 0 auto;
		margin-top: 20px;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.modularBox>.modularContent::-webkit-scrollbar {
		width: 0;
	}

	.contentbox {
		background: #FFFFFF;
		overflow: hidden;
	}

	/*内容盒子里的内容*/
	.bodybox {
		width: 100%;
		margin: 0 auto;
		// margin-top: 26px;
		overflow: hidden;
		/*border: 1px red solid;*/
		height: 682px;
		overflow: hidden;
	}

	.bodybox>div {
		margin-top: 10px;
		display: flex;
		font-size: 14px;

	}

	.bodybox>.PatentNature {
		width: 98%;
		margin: 0 auto;
		margin-top: 20px;
	}

	.bodybox>.PatentNature>div {
		width: calc((100% - 0px)/3);
		line-height: 28px;
		/*margin-right: 20px;*/
	}

	.bodybox>.PatentNature>div>div:first-child {
		width: 80px;
		text-align: right;
	}

	.bodybox>.PatentNature>div>.inputbox {
		width: 273px;
		height: 28px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
		line-height: 28px;
		padding-left: 4px;
		color: #A0A0A0;
		font-size: 14px;
	}

	.querybtn {
		width: 56px;
		height: 28px;
		background: #094AAE;
		border-radius: 5px;
		line-height: 28px;
		text-align: center;
		color: #FFFFFF;
	}

	.PatentNature .emptybtn {
		margin-left: 20px;
	}

	.emptybtn {
		width: 56px;
		height: 28px;
		background: #4D8F00;
		border-radius: 5px;
		line-height: 28px;
		text-align: center;
		color: #FFFFFF;
	}

	/* table */
	.tablebox {
		width: 1068px;
		margin: 0 auto;
		border-top: 1px solid #E5E5E5;
		border-right: 1px solid #E5E5E5;
		border-left: 1px solid #E5E5E5;
	}

	/deep/.el-table__header th {
		padding: 0;
		line-height: 40px;
		height: 40px;
		background: #D8D8D8;
		font-weight: bold;
		color: #333333;
		font-size: 14px;

	}

	/deep/ .el-table__body td {
		padding: 0;
		height: 40px;
		line-height: 40px;
		color: #333333;
		font-size: 14px;
	}

	.btnbox {
		width: 100%;
		border-top: 1px solid #E5E5E5;
		padding: 10px;

		div {
			margin-left: 20px;
		}
	}

	.fenye {
		float: right;
		margin-right: 40px;
	}

	.el-pagination {
		margin-top: 10px;
	}
</style>
